import { gql } from '@apollo/client';

export const GET_HAS_NEWS = gql`
  query GetHasNews {
    hasNews @client
  }
`;
